/* src/app/admin-dashboard/delivery/routes/routes.component.css */
.dr-wrap {
  padding: 16px;
}
.dr-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}
.dr-spacer {
  flex: 1 1 auto;
}
.dr-note {
  margin: 0;
  color: #555;
  font-size: 13px;
  max-width: 760px;
}
.dr-muted {
  color: #888;
  font-size: 12px;
}
.dr-error {
  color: #c0392b;
  padding: 8px 0;
}
.dr-empty {
  padding: 20px;
  text-align: center;
  color: #888;
  font-size: 13px;
}
.dr-chip {
  border-radius: 12px;
  padding: 3px 9px;
  font-size: 12px;
  font-weight: 600;
  background: #eef1f4;
  color: #555;
  white-space: nowrap;
}
.dr-chip-warn {
  background: #fdecea;
  color: #c0392b;
}
.dr-chip-off {
  background: #f0f0f0;
  color: #888;
}
.dr-layout {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  flex-wrap: wrap;
}
.dr-list-pane {
  flex: 0 0 300px;
  min-width: 260px;
  border: 1px solid #e3e6ea;
  border-radius: 8px;
  background: #fff;
  padding: 10px;
}
.dr-list-head {
  display: flex;
}
.dr-search {
  width: 100%;
}
.dr-search-full {
  width: 100%;
}
.dr-search .mat-mdc-form-field-icon-prefix {
  padding-right: 6px;
  color: #888;
}
.dr-new {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 8px;
}
.dr-new-field {
  flex: 1 1 auto;
}
.dr-route-item {
  padding: 8px 10px;
  border-radius: 6px;
  cursor: pointer;
  border: 1px solid transparent;
}
.dr-route-item:hover {
  background: #f5f7f9;
}
.dr-route-selected {
  background: #eef5ff;
  border-color: #c9dcf7;
}
.dr-route-off {
  opacity: .6;
}
.dr-route-main {
  display: flex;
  align-items: center;
  gap: 8px;
}
.dr-route-name {
  font-weight: 500;
  font-size: 14px;
}
.dr-edit-pane {
  flex: 1 1 520px;
  min-width: 420px;
  border: 1px solid #e3e6ea;
  border-radius: 8px;
  background: #fbfcfd;
  padding: 14px;
}
.dr-edit-empty {
  color: #888;
  text-align: center;
  padding: 40px 16px;
}
.dr-edit-head {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
}
.dr-field {
  flex: 1 1 220px;
  min-width: 200px;
}
.dr-field-sm {
  flex: 0 0 170px;
}
.dr-columns {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  flex-wrap: wrap;
  margin-top: 8px;
}
.dr-stops {
  flex: 1 1 340px;
  min-width: 320px;
}
.dr-picker {
  flex: 0 0 280px;
  min-width: 240px;
}
.dr-section-head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 6px;
  flex-wrap: wrap;
}
.dr-optimize {
  margin-left: auto;
}
.dr-optim-msg {
  margin: 4px 0 8px;
  padding: 8px 12px;
  border-radius: 6px;
  background: #fdf3e0;
  color: #8a6417;
  font-size: 13px;
}
.dr-optim-proposal {
  margin: 4px 0 10px;
  padding: 12px;
  border: 1px solid #c9dcf7;
  border-radius: 8px;
  background: #eef5ff;
}
.dr-optim-head {
  font-size: 13px;
  margin-bottom: 8px;
}
.dr-optim-list {
  margin: 0 0 10px;
  padding-left: 22px;
  font-size: 13px;
}
.dr-optim-list li {
  padding: 2px 0;
}
.dr-optim-actions {
  display: flex;
  gap: 8px;
}
.dr-stop-list {
  border: 1px solid #e3e6ea;
  border-radius: 6px;
  background: #fff;
  min-height: 40px;
}
.dr-stop {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  border-bottom: 1px solid #f0f0f0;
  background: #fff;
}
.dr-stop:last-child {
  border-bottom: none;
}
.dr-handle {
  cursor: grab;
  color: #bbb;
}
.dr-stop-order {
  width: 22px;
  text-align: center;
  font-weight: 600;
  color: #666;
  font-size: 13px;
}
.dr-stop-body {
  flex: 1 1 auto;
  min-width: 0;
}
.dr-stop-name {
  font-size: 13px;
  font-weight: 500;
}
.dr-stop-note {
  width: 100%;
  border: none;
  outline: none;
  font-size: 12px;
  color: #777;
  padding: 2px 0;
  background: transparent;
}
.dr-stop-note::placeholder {
  color: #bbb;
}
.dr-minutes {
  width: 70px;
}
.dr-minutes .mat-mdc-form-field-subscript-wrapper {
  display: none;
}
.cdk-drag-preview {
  box-shadow: 0 4px 12px rgba(0, 0, 0, .18);
  border-radius: 6px;
}
.cdk-drag-placeholder {
  opacity: .35;
}
.cdk-drop-list-dragging .dr-stop:not(.cdk-drag-placeholder) {
  transition: transform 200ms cubic-bezier(0, 0, .2, 1);
}
.dr-picker-list {
  border: 1px solid #e3e6ea;
  border-radius: 6px;
  background: #fff;
  max-height: 340px;
  overflow-y: auto;
}
.dr-picker-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  cursor: pointer;
  font-size: 13px;
}
.dr-picker-item:hover {
  background: #eef5ff;
}
.dr-picker-name {
  font-weight: 500;
}
.dr-add {
  color: #6b9bd8;
  font-size: 18px;
  height: 18px;
  width: 18px;
}
.dr-run {
  margin-top: 16px;
  border-top: 1px solid #e3e6ea;
  padding-top: 12px;
}
.dr-run-row {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
}
.dr-bulk {
  border: 1px solid #e3e6ea;
  border-radius: 6px;
  background: #fff;
  padding: 4px 8px;
  margin-bottom: 6px;
}
.dr-bulk-row {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}
.dr-bulk-count {
  font-size: 12px;
  color: #888;
}
.dr-bulk-on {
  color: #1d6ef2;
  font-weight: 600;
}
.dr-day {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  border: 1px solid #d6dbe1;
  border-radius: 14px;
  padding: 3px 9px;
  font-size: 12px;
  color: #555;
}
.dr-day-on {
  border-color: #1d6ef2;
  color: #1d6ef2;
  background: #eef5ff;
  font-weight: 600;
}
.dr-day input {
  margin: 0;
}
.dr-stop-check {
  margin-right: 2px;
}
.dr-stop-picked {
  background: #eef5ff;
}
.dr-days {
  display: inline-block;
  margin-left: 8px;
  cursor: pointer;
  border-radius: 10px;
  padding: 1px 8px;
  font-size: 11px;
  font-weight: 600;
  background: #f0f2f5;
  color: #888;
}
.dr-days-custom {
  background: #fdf3e0;
  color: #8a6417;
}
.dr-row-action {
  width: 30px;
  height: 30px;
  line-height: 30px;
}
.dr-row-action .mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #7d8790;
}
.dr-bulk-note {
  padding: 2px 4px 6px;
}
.dr-route-main {
  flex-wrap: wrap;
}
.dr-route-name {
  min-width: 0;
  overflow-wrap: anywhere;
}
.dr-title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
}
.dr-run-summary {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  padding: 4px 0;
}
.dr-run-help {
  margin: 8px 0 12px;
  max-width: 720px;
}
.dr-edit-head {
  padding-bottom: 8px;
  border-bottom: 1px solid #e3e6ea;
  margin-bottom: 8px;
}
.dr-input {
  display: flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  box-sizing: border-box;
  border: 1px solid #d6dbe1;
  border-radius: 6px;
  background: #fff;
  padding: 0 8px;
  width: 100%;
}
.dr-input:focus-within {
  border-color: #1d6ef2;
}
.dr-input input {
  flex: 1 1 auto;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  font-size: 14px;
}
.dr-input .mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #888;
}
.dr-input-clear {
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  display: flex;
}
.dr-list-head {
  margin-bottom: 8px;
}
.dr-new {
  margin-bottom: 12px;
}
.dr-new .mat-mdc-button-base {
  height: 36px;
}
.dr-route-item {
  padding: 10px;
  margin-bottom: 4px;
}
.dr-route-main {
  flex-wrap: nowrap;
  min-height: 28px;
}
.dr-route-name {
  flex: 1 1 auto;
  font-size: 14px;
}
.dr-route-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 4px;
}
.dr-row-action {
  flex: 0 0 auto;
}
.dr-stop {
  padding: 4px 8px;
}
.dr-stop-body {
  padding: 2px 0;
}
.dr-minutes {
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 0 0 auto;
  border: 1px solid #d6dbe1;
  border-radius: 6px;
  padding: 0 8px;
  height: 32px;
  background: #fff;
}
.dr-minutes input {
  width: 36px;
  border: none;
  outline: none;
  text-align: right;
  font-size: 14px;
  background: transparent;
}
.dr-minutes span {
  font-size: 12px;
  color: #888;
}
.dr-picker-list {
  max-height: 520px;
}
.dr-route-item {
  border: 1px solid #e3e6ea;
  border-radius: 8px;
  background: #fff;
  padding: 12px 12px 10px;
  margin-bottom: 8px;
  transition: box-shadow .15s, border-color .15s;
}
.dr-route-item:hover {
  background: #fff;
  border-color: #c9d2dc;
  box-shadow: 0 1px 4px rgba(0, 0, 0, .08);
}
.dr-route-selected,
.dr-route-selected:hover {
  background: #eef5ff;
  border-color: #1d6ef2;
  box-shadow: inset 3px 0 0 #1d6ef2;
}
.dr-route-name {
  font-size: 15px;
  font-weight: 600;
  color: #222;
}
.dr-route-meta {
  gap: 14px;
  margin-top: 6px;
}
.dr-meta-item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: #555;
}
.dr-meta-item .mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  color: #8a949e;
}
.dr-meta-warn,
.dr-meta-warn .mat-icon {
  color: #c0392b;
}
.dr-route-off .dr-route-name {
  color: #777;
}
.dr-list-head {
  display: flex;
  align-items: center;
  gap: 8px;
}
.dr-add-route {
  flex: 0 0 auto;
  width: 36px;
  height: 36px;
}
.dr-edit-title h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}
.dr-edit-sub {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #666;
  margin-top: 2px;
}
.dr-edit-sub .mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  color: #8a949e;
}
.dr-map-card {
  margin-top: 12px;
  border: 1px solid #e3e6ea;
  border-radius: 8px;
  background: #fff;
  padding: 8px 12px 10px;
}
.dr-map-card .dr-section-head {
  margin-bottom: 4px;
}
.dr-map-wrap {
  position: relative;
}
.dr-map {
  height: 340px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e3e6ea;
}
.dr-map-base {
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 500;
  padding: 7px 12px;
  border-radius: 8px;
  border: 1px solid #d5d9de;
  background: rgba(255, 255, 255, .94);
  color: #333;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}
.dr-map-warn {
  margin: 6px 0 0;
  font-size: 12px;
  color: #8a6417;
}
.dr-map-big {
  height: 78vh;
  min-height: 480px;
}
.dr-map-expand {
  position: absolute;
  right: 110px;
  top: 10px;
  z-index: 500;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 5px 12px 5px 8px;
  border-radius: 8px;
  border: 1px solid #d5d9de;
  background: rgba(255, 255, 255, .94);
  color: #333;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}
.dr-map-expand .mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.dr-map-hint {
  margin: 6px 0 0;
  font-size: 12px;
  color: #777;
}
/*# sourceMappingURL=routes.component.css.map */
